// Central campaign constants for the IWF Atlanta 2026 landing page.
//
// POST-SHOW MODE (Sept 1, 2026 → Sept 30, 2026 offer window):
//   IWF Atlanta ran Aug 25–28. The page is now converting badge-scan leads and
//   post-show attendees, not selling booth visits. Booth-visit copy has been
//   past-tensed and the discount deadline is the entire remaining play.
//
// The page renders at /iwf-2026 (aliased from /iwf and /iwf2026 via
// next.config.js redirects). Everything a non-engineer needs to update lives
// here — booth number (for the recap), the standard demo link, the discount
// code string, and the redemption deadline.

import { demoBookingUrl } from '../../../../data/demoBooking';

export const IWF = {
  // --- Show + booth (retained for the "Thanks for stopping by" recap) -----
  show: 'IWF Atlanta 2026',
  booth: 'BC410',
  hall: 'Hall BC',
  dates: 'Aug 25–28, 2026',
  datesIso: { start: '2026-08-25', end: '2026-08-28' },
  city: 'Atlanta, GA',
  venue: 'Georgia World Congress Center',

  // --- Offer --------------------------------------------------------------
  discountCode: 'IWF26', // must match the Stripe coupon
  discountPct: 25,
  discountMonths: 3,
  redeemBy: 'September 30, 2026',
  redeemByIso: '2026-09-30', // for countdown math + banner sunset
  trialLength: '14-day free trial',
  // Included for every IWF attendee who signs up before redeemBy.
  //
  // §6 value anchor approved by Steph on 2026-09-01: $499. The pricing card
  // callout uses this to render "(a $499 value)" so attendees see what the
  // free implementation session is actually worth.
  impSessionValueAnchor: '$499',

  // --- Links --------------------------------------------------------------
  // Post-show: the old booth-slot Calendly link
  //   https://calendly.com/timbercloud/iwf-2026?utm_source=iwf&utm_medium=event&utm_campaign=iwf-2026
  // pointed at a Calendly event type that no longer exists post-show. We swap
  // to the STANDARD demo link that every other marketing CTA on the site
  // uses (src/data/demoBooking.js), keeping the same utm_* chain so Calendly's invitee.created
  // webhook (pages/api/calendly-webhook.js) still attributes bookings back to
  // the IWF campaign via utm_campaign=iwf-2026. Change the UTMs and IWF
  // bookings silently start reporting as generic demo demand.
  calendlyUrl: demoBookingUrl({
    utm_source: 'iwf',
    utm_medium: 'event',
    utm_campaign: 'iwf-2026',
  }),
  signupUrl: '/create-account',
};
